import React from 'react';

import { ChartContainer, ChartContent, ChartIcon } from './styles';

interface ChartSkeletonProps {
  width?: number | string;
  height?: number | string;
}

const ChartSkeleton: React.FC<ChartSkeletonProps> = ({
  width = 360,
  height = 240,
}) => {
  return (
    <ChartContainer width={width} height={height}>
      <ChartContent>
        <ChartIcon />
      </ChartContent>
    </ChartContainer>
  );
};

export default ChartSkeleton;
